import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { fetchReferalManagerAffiliates } from '../services/api';

export default function ListAffiliate() {
    // Add table state
  const [affiliates, setAffiliates] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [setSnackbar] = useState({ 
    open: false, 
    message: '', 
    severity: 'success' 
  });
  const { fetchPartnerName } = useAuth();

  // Function to format currency in IDR
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  useEffect(() => {
    const loadAffiliates = async () => {
      setTableLoading(true);
      try {
        let affiliateData = await fetchReferalManagerAffiliates(fetchPartnerName());
        setAffiliates(affiliateData);
      } catch (error) {
        console.error('Error loading affiliates:', error);
        setSnackbar({
          open: true,
          message: 'Failed to load affiliates',
          severity: 'error'
        });
      } finally {
        setTableLoading(false);
      }
    };
    loadAffiliates();
  }, [setSnackbar, fetchPartnerName]);

  return (

    <Box sx={{ width: '100%', p: 2 }}>
      <Paper elevation={2} sx={{ p: 3, mb: 4 }}>
      <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3, mb: 2 }}>
          {fetchPartnerName()} - List of Affiliates
        </Typography>
        
        {tableLoading ? (
          <CircularProgress />
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Partner</TableCell>
                  <TableCell>Rate</TableCell>
                  <TableCell>Total Purchase</TableCell>
                  <TableCell>Total Commission</TableCell>
                  <TableCell>Total Voucher</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {affiliates.map((affiliate) => (
                  <TableRow key={affiliate.id}>
                    <TableCell>{affiliate.name}</TableCell>
                    <TableCell>{affiliate.email}</TableCell>
                    <TableCell>{affiliate.partner_name}</TableCell>
                    <TableCell>{affiliate.commission_rate}%</TableCell>
                    <TableCell>{formatCurrency(affiliate.total_purchases)}</TableCell>
                    <TableCell>{formatCurrency(affiliate.total_commission)}</TableCell>
                    <TableCell>{affiliate.total_vouchers}</TableCell>
                    <TableCell>
                      <Chip 
                        label={affiliate.status} 
                        color={affiliate.status === 'ACTIVE' ? 'success' : 'error'}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
      </Box>
  );
}